
































import Vue from "vue";
import moment from "moment";
import Component from "vue-class-component";
import { SocialMedia as SMInterface } from "../../services/social-media/entities/social-media.interface";
import constants from "../../config/constants";

@Component
export default class Footer extends Vue {
  private openURL(url: string): void {
    window.open(url);
  }

  private get copyrightDate(): string {
    return moment().format("YYYY");
  }

  private created(): void {
    this.$store.dispatch("socialMedia/getSocialMedia");
  }

  private get socialMedia(): Array<SMInterface> {
    const socialMedia = this.$store.getters["socialMedia/getSocialMedia"];

    const result = socialMedia.filter(
      (socialM: SMInterface) =>
        socialM.socialMediaStatus == constants.STATUS.ACTIVE
    );

    return result;
  }
}
